import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient.ts';

function PrevArrow(props) {
  const { className, onClick } = props;
  return (
    <button type="button" className={className} onClick={onClick}>
      <img src="img/icon/arrow.png" alt="PREV" />
    </button>
  );
}

function BreedServices() {
  const [breeds, setBreeds] = useState([]);
  const [sectionInfo, setSectionInfo] = useState({ subtitle: '', description: '' });

  const settings = {
    nav: true,
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    arrows: true,
    prevArrow: <PrevArrow />,
    autoplaySpeed: 4000,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 992, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false } },
      { breakpoint: 575, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false } },
    ]
  };

  useEffect(() => {
    const fetchData = async () => {
      const { data: breedData, error: breedError } = await supabase
        .from('breeds')
        .select('*')
        .order('order_index', { ascending: true });

      const { data: sectionData, error: sectionError } = await supabase
        .from('breed_section')
        .select('*')
        .single(); // since there's only one

      if (breedError) console.error('Breed fetch error:', breedError);
      else setBreeds(breedData);

      if (sectionError) console.error('Section info error:', sectionError);
      else setSectionInfo(sectionData);
    };

    fetchData();
  }, []);

  return (
    <section className="breeds-services pt-110 pb-110">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-9">
            <div className="section-title text-center mb-65">
              <div className="section-icon"><img src="img/icon/pawprint.png" alt="" /></div>
              <h5 className="sub-title">{sectionInfo.subtitle}</h5>
              <p>{sectionInfo.description}</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-8">
            <Slider className="breed-services-active slick" {...settings}>
              {breeds.map((item) => (
                <div className="breed-services-item" key={item.id}>
                  <div className="thumb">
                    <img src={item.image_url} alt={item.title} />
                  </div>
                  <div className="content">
                    <h3 className="title"><Link to="#">{item.title}</Link></h3>
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="breed-services-info" style={{ backgroundImage: 'url("img/bg/breed_services_bg.png")' }}>
              <h5 className="sub-title">Animalia +</h5>
              <p>
                Chez Animalia Plus, nous mettons tout en œuvre pour offrir à vos compagnons à quatre pattes les meilleurs produits
                et soins. Découvrez notre sélection d’articles pour chiens, allant de la nutrition haut de gamme aux jouets
                éducatifs, en passant par les accessoires d’hygiène et de bien-être.
              </p>
              <Link to="/doglist" className="btn">
                Plus de Produits <img src="img/icon/w_pawprint.png" alt="" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="breed-services-shape">
        <img src="img/images/breed_services_shape01.png" alt="" />
      </div>
      <div className="breed-services-shape shape-two">
        <img src="img/images/breed_services_shape02.png" alt="" />
      </div>
    </section>
  );
}

export default BreedServices;
